import { PropsOrComponent } from "../modals";
import { propsOrComponent } from "./props-or-component";

export const createDynamicComponent = (elem:{Component: any, props: any}) => {
  return elem ? <elem.Component {...elem.props} /> : <>No component was passed</>;
}

export const createFromPropsOrComponent = <TProps extends {}>(
  elem: PropsOrComponent<TProps>, Component?: React.Component<TProps>
) => {
  const { Component: C, props } = propsOrComponent(elem, Component);
  return <C {...props} />;
};
